import { Injectable, OnDestroy, OnInit } from '@angular/core';

import { Observable ,  BehaviorSubject ,  Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FormService implements OnDestroy {
  constructor() {}

  private onSaveClick = new Subject<boolean>();
  private onSaveAndCloseClick = new Subject<boolean>();
  private onCloseClick = new Subject<boolean>();
  private isFormEdit = new BehaviorSubject<boolean>(false);
  public readonly showSaveBtn$ = this.isFormEdit.asObservable();

  saveClick(param?: boolean): void {
    if (param === undefined) {
      this.onSaveClick.next(true);
    } else {
      this.onSaveClick.next(false);
    }   
  }

  saveEvent(): Observable<boolean> {
    return this.onSaveClick.asObservable();
  }
  
  closeClick(): void {
    this.onCloseClick.next(true);
  }

  closeEvent(): Observable<boolean> {
    return this.onCloseClick.asObservable();
  }

  formEdit(b: boolean): void {
    this.isFormEdit.next(b);
  }

  isFormOnEdit(): Observable<boolean> {
    return this.isFormEdit.asObservable();
  }

  ngOnDestroy() {
    this.onSaveClick.complete();
    this.onSaveAndCloseClick.complete();
    this.isFormEdit.complete();
    this.onCloseClick.complete();
  }
}